export const grants = [
  'read_vehicles',
  'write_vehicles',
  'read_expenses',
  'write_expenses'
]

export default grants



// WEBPACK FOOTER //
// ./src/grants.js